// src/services/tenant.js
export const getTenantSlug = () => {
    const hostname = window.location.hostname

    // difatech.viaxii.com → 'difatech'
    // localhost → 'difatech' (para desarrollo)

    if (hostname === 'localhost' || hostname === '127.0.0.1') {
        return import.meta.env.VITE_DEV_TENANT ?? 'difatech'
    }

    const parts = hostname.split('.')

    // partes: ['difatech', 'viaxii', 'com']

    if (parts.length >= 3) return parts[0]

    return null  // viaxii.com sin subdominio → landing
}
